import { Component, AfterViewInit, inject, input, output, viewChild, effect } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmDialogComponent } from '@app/components/_common/confirm-dialog/confirm-dialog.component';
import { Evaluation } from '@app/models/enseignant';
import { SnackbarService } from '@app/services';
import { EnseignantService } from '@app/services/enseignant.service';

@Component({
  selector: 'app-evaluation-table-view',
  templateUrl: './evaluation-table-view.component.html',
  styleUrls: ['./evaluation-table-view.component.scss'],
  standalone: false
})
export class EvaluationTableViewComponent implements AfterViewInit {

  displayedColumns: string[] = ['numEvaluation', 'type', 'libelle', 'dateDebut', 'discipline', 'cours', 'actions'];
  dataSource = new MatTableDataSource<any>();

  evaluations = input<Evaluation[]>();
  idEnseignant = input<number>();
  totalItems = input<number>();
  pageSize = input<number>();
  pageIndex = input<number>();
  pageSizeOptions = input<number[]>();
  deleteEvaluation = output<number>();
  pageChange = output<PageEvent>();

  enseignantService = inject(EnseignantService);
  snackbarService = inject(SnackbarService);
  dialog = inject(MatDialog);
  leavingRows = new Set<number>();

  sort = viewChild(MatSort);
  paginator = viewChild(MatPaginator);

  constructor() {
    effect(() => {
      const _ = this.totalItems(); // Déclencheur
      const newData = this.evaluations();
      this.dataSource.data = newData;
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort();
    this.dataSource.paginator = this.paginator();
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'numEvaluation': return Number(item.numEvaluation);
        case 'type': return item.examen;
        case 'libelle': return item.libelle?.toLowerCase();
        case 'dateDebut': return new Date(item.dateDebut).getTime();
        case 'discipline': return item.discipline?.libelle?.toLowerCase();
        case 'cours': return item.cours?.libelle?.toLowerCase();
        default: return item[property];
      }
    };
  }

  onPageChange(event: PageEvent): void {
    this.pageChange.emit(event);
  }

  confirmDelete(evaluation: Evaluation): void {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      data: { message: `Voulez-vous supprimer l'évaluation n°${evaluation.numEvaluation} ?` }
    });

    ref.afterClosed().subscribe(result => {
      if (result) {
        this.leavingRows.add(evaluation.idEvaluation); // ajoute une classe CSS animée
        this.enseignantService.deleteEvaluation(evaluation.idEvaluation, this.idEnseignant()).subscribe({
          next: () => {
            this.leavingRows.add(evaluation.idEvaluation);

            setTimeout(() => {
              this.leavingRows.delete(evaluation.idEvaluation);
              this.deleteEvaluation.emit(evaluation.idEvaluation);
            }, 300);
            this.snackbarService.info(`L'évaluation n°${evaluation.numEvaluation} a été supprimée`);
          },
          error: (err) => {
            this.snackbarService.error(`Échec de la suppression de l'évaluation`);
          }
        });
      }
    });
  }
}
